module.exports = __webpack_public_path__ + "static/media/combo.3e9b32f2.png";